import React from 'react'
import PropTypes from 'prop-types'

import { getFormattedAddress } from '../../utils/address-helpers'

import './SavedAddressLabel.css'

export const SavedAddressLabel = React.memo(({
  savedAddress: {
    name,
    deliveryInfo
  }
}) => (
  <span styleName='address'>
    <div styleName='addressInfo'>
      <div>
        {name && <p styleName='name'>{name}</p>}
        <p styleName='formattedAddress'>
          {getFormattedAddress(deliveryInfo)}
          {deliveryInfo.address2 && (
            <span>{deliveryInfo.address2}</span>
          )}
        </p>
        {deliveryInfo.notes && <p styleName='notes'>{deliveryInfo.notes}</p>}
      </div>
    </div>
  </span>
))

SavedAddressLabel.displayName = 'SavedAddressLabel'

const SavedAddressShape = PropTypes.shape({
  guid: PropTypes.string.isRequired,
  name: PropTypes.string,
  deliveryInfo: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    notes: PropTypes.string
  })
})
SavedAddressLabel.propTypes = {
  savedAddress: SavedAddressShape.isRequired
}
